import { Component, OnInit } from '@angular/core';

import {Router} from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-console-view',
  templateUrl: './console-view.component.html',
  styleUrls: ['./console-view.component.css']
})
export class ConsoleViewComponent implements OnInit {
	fileName="";
	respObject: any;
	sView=false;
	fView=false;
	fhView=false;
	curIndex=0;
  userRole=localStorage.getItem('userRole');
  paramTypes = "";
  domotor= ["Motor2W","Motor3W","Motor 4W Pvt Car","Motor CV Pass Carry","Motor CV Goods Carry","Motor CV Miscellaenous","Motor Others"];
  constructor(private router: Router,private route: ActivatedRoute, private _rest: RestapiService) { }

  ngOnInit(): void {
  	this.route.params.forEach((params: Params) => {
  		/*if(params['type']=="Segment"){
  			this.sView=true;
  			this.fView=false;
  			this.fhView=false;
  		} else if(params['type']=="Financial_Highlights"){
  			this.sView=false;
  			this.fView=false;
  			this.fhView=true;
  		} else {
  			this.sView=false;
  			this.fView=true;
  			this.fhView=false;
  		}*/
      this.paramTypes=params['type'];
  		this.curIndex=params['sheetIndex'];
  		this.fileName=params['fileName'];
  		var data = {"fileName":params['fileName'],"sheetIndex":params['sheetIndex']};
  		this._rest.getConsoleView(data).subscribe((res) => {
  			this.respObject = res;
  			document.getElementById("bootstrap-data-table").innerHTML=this.respObject.resp;
  		});
     });
  }
  changeTab(indx,fn){
  	this.curIndex = indx;
    if (this.userRole=="compliance") {
      this.router.navigate(['/compliance/consoleview/Segment/'+indx+'/'+fn]);
    }else{
      this.router.navigate(['/analyst/consoleview/Segment/'+indx+'/'+fn]);
    }
  }
  changeTab1(indx,fn){
  	this.curIndex = indx;
    if (this.userRole=="compliance") {
  	  this.router.navigate(['/compliance/consoleview/Form/'+indx+'/'+fn]);
    }else{
      this.router.navigate(['/analyst/consoleview/Form/'+indx+'/'+fn]);
    }
  }
  changeTabFn(indx,fn){
  	this.curIndex = indx;
    if (this.userRole=="compliance") {
      this.router.navigate(['/compliance/consoleview/Financial_Highlights/'+indx+'/'+fn]);
    }else{
      this.router.navigate(['/analyst/consoleview/Financial_Highlights/'+indx+'/'+fn]);
    }
  }
  changeTabRn(indx,fn){
  	this.curIndex = indx;
    if (this.userRole=="compliance") {
      this.router.navigate(['/compliance/consoleview/Reinsurance/'+indx+'/'+fn]);
    }else{
      this.router.navigate(['/analyst/consoleview/Reinsurance/'+indx+'/'+fn]);
    }
  }
  // changeTabmp(indx,fn){
  // 	this.curIndex = indx;
  //   if (this.userRole=="compliance") {
  //     this.router.navigate(['/compliance/consoleview/MotorPremium/'+indx+'/'+fn]);
  //   }else{
  //     this.router.navigate(['/analyst/consoleview/MotorPremium/'+indx+'/'+fn]);
  //   }
  // }

  changeTabDynamic(i,fileName,paramTypes){
    this.curIndex = i;
    if (this.userRole=="compliance") {
      this.router.navigate(['/compliance/consoleview/'+paramTypes+'/'+i+'/'+fileName]);
    }else{
      this.router.navigate(['/analyst/consoleview/'+paramTypes+'/'+i+'/'+fileName]);
    }
  }
  backfile(){
    if (this.userRole=="compliance") {
  	  this.router.navigate(['/compliance/consolereports']);
    }else{
      this.router.navigate(['/analyst/consoleReport']);
    }
  }
}
